import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  passwordError: String;
  public loadingRequest: boolean;
  public showErrors: boolean;
  public showSuccess: boolean = false;

  constructor(private AuthenticationService: AuthenticationService, private router: Router) { }

  ngOnInit() {

  }

  requestPassword(email: String) {
    this.loadingRequest = true;
    if(!email){
      this.passwordError = "Enter a valid email.";
      this.loadingRequest = false;
    }
    else {
      this.AuthenticationService.requestPasswordResetLink(email).subscribe(data => {
        this.showSuccess = true;
        this.loadingRequest = false;
      },
      err => {
        this.loadingRequest = false;
        if(err.error[0]){
          this.passwordError = err.error[0].msg;
        }
        else {
          this.passwordError = err.error.msg;
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/login/forgot-password/forgot-password.component.ts